// Google Analytics / Zaraz event tracking utility
// Fires events to GA4 via Cloudflare Zaraz (single source of truth)

/**
 * Track a custom event for Google Analytics / Google Ads conversions
 * @param {string} eventName - Event name (e.g., 'survey_submit', 'prompt_submit')
 * @param {object} params - Event parameters
 */
export function trackEvent(eventName, params = {}) {
  try {
    // Debug: Log to console
    console.log('[Analytics] Firing event:', eventName, params)
    
    // Cloudflare Zaraz - single source of truth for analytics
    if (typeof window !== 'undefined' && window.zaraz?.track) {
      window.zaraz.track(eventName, params)
      console.log('[Analytics] Sent via zaraz.track')
    } else {
      console.warn('[Analytics] Zaraz not available')
    }
  } catch (e) {
    console.error('[Analytics] Error:', e)
  }
}

/**
 * Track survey submission
 * @param {boolean} isDyslexic - Whether user identified as dyslexic
 */
export function trackSurveySubmit(isDyslexic) {
  trackEvent('survey_submit', {
    is_dyslexic: isDyslexic,
    event_category: 'research',
    event_label: isDyslexic ? 'dyslexic' : 'non_dyslexic'
  })
}

/**
 * Track survey skip
 */
export function trackSurveySkip() {
  trackEvent('survey_skip', {
    event_category: 'research',
    event_label: 'skipped'
  })
}

/**
 * Track prompt submission to AI
 * @param {boolean} surveyCompleted - Whether user completed survey
 * @param {boolean} isDyslexic - Whether user identified as dyslexic
 * @param {string} provider - AI provider used
 */
export function trackPromptSubmit(surveyCompleted, isDyslexic, provider) {
  // Conversion value: dyslexic users who completed survey = highest value
  // This helps Google Ads optimize for finding dyslexic users
  let conversionValue = 1  // Base value for any prompt
  if (surveyCompleted && isDyslexic) {
    conversionValue = 10  // 10x value for dyslexic users
  } else if (surveyCompleted) {
    conversionValue = 2   // 2x value for surveyed non-dyslexic users
  }
  
  trackEvent('prompt_submit', {
    survey_completed: surveyCompleted,
    is_dyslexic: isDyslexic,
    provider: provider,
    event_category: 'ai_interaction',
    // Composite label for easy filtering in Google Ads
    event_label: surveyCompleted 
      ? (isDyslexic ? 'dyslexic_surveyed' : 'surveyed') 
      : 'no_survey',
    // Conversion value for Google Ads optimization
    value: conversionValue,
    currency: 'USD'
  })
}
